export const RPC_EVENT_TYPE = 'rpc';
